import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./index.scss";
import { Form } from "react-bootstrap";
import searchIcon from "../../../../Assets/icons/searchicon.svg";
// import Select from "react-select";
import viewDetailsIcon from "../../../../Assets/icons/viewDetails.svg";
import revenueIcon from "../../../../Assets/images/DashboardRevenue.png";
import ServiceIcon from "../../../../Assets/images/ServiceReportIcon.png";
import arrowUpIcon from "../../../../Assets/icons/arrow-up 1.svg";
import { useNavigate } from "react-router-dom";
import DetailsTable from "../../Logistics/PO Approval/PoApprovalDetails/DetailsTable";
import Chart from "react-apexcharts";
import SimpleChart from "./SimpleChart/SimpleChart";
import axiosInstance from "../../../services/api/API";
import CanvasJSReact from "@canvasjs/react-charts";
// import { Form } from "react-bootstrap";
import Select from "react-select";
// import { format } from 'date-fns';
import { format, subDays, subWeeks, subMonths, subYears } from "date-fns";
import { MdAccessTime } from "react-icons/md";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const ServiceDashboard = ({ card_id }) => {
  const token = localStorage.getItem("authToken");
  const dealer_id = localStorage.getItem("dealerId");
  const userType = localStorage.getItem("UserType");
  console.log(dealer_id, "dealerIddddd");

  const engineerId = localStorage.getItem("engineer_id");

  const navigate = useNavigate();
  const navigateToService = () => {
    navigate("/manage-services/check-warranty");
  };

  const [syncId, setSyncId] = useState("syncChart");

  const [selectedDealerId, setSelectedDealerId] = useState(null);
  const [firstRowData, setFirstRowData] = useState({});
  const [secondRowData, setSecondRowData] = useState({});
  const [graphDataVal, setGraphDataVAl] = useState({});
  const [filterYear, setFilterYear] = useState("");
  const [variantOptions, setVariantOptions] = useState([]);
  const [filterVariant, setFilterVariant] = useState("");
  const [revenueAmount, setRevenueAmount] = useState();
  const [activeFilter, setActiveFilter] = useState("24Hours");

  const [dealerDd, setDealerdd] = useState([]);
  //   useEffect(() => {
  //     salesDashboardDetails(filter);
  // }, [filter]);
  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().split("T")[0]; // 'YYYY-MM-DD'

  const formattedToday = currentDate.toISOString().split("T")[0];

  const yesterday = new Date(currentDate);
  yesterday.setDate(currentDate.getDate() - 1);
  const formattedYesterday = yesterday.toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(formattedYesterday);
  const [toDate, setToDate] = useState(formattedToday);

  useEffect(() => {
    Dealerdropdown();
  }, []);

  const Dealerdropdown = async (id) => {
    try {
      const response = await axiosInstance.post(
        "/dealer/ddldealer",
        // { business_partner_id: 1 },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.dealer_id,
        label: user.dealer_name,
      }));
      setDealerdd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDateSelection = (period) => {
    let fromDate;
    const currentDate = new Date();

    switch (period) {
      case "24Hours":
        fromDate = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000); // Last 24 hours
        break;
      case "Week":
        fromDate = subWeeks(currentDate, 1); // Last week
        break;
      case "Month":
        fromDate = subMonths(currentDate, 1); // Last month
        break;
      case "Year":
        fromDate = subYears(currentDate, 1); // Last year
        break;
      default:
        fromDate = currentDate;
    }

    // Format dates as 'YYYY-MM-DD'
    const formattedFromDate = format(fromDate, "yyyy-MM-dd");
    const formattedToDate = format(currentDate, "yyyy-MM-dd");
    setActiveFilter(period);
    setFromDate(formattedFromDate);
    setToDate(formattedToDate);
    // Call your function with the formatted dates
    salesDashboardDetails(formattedFromDate, formattedToDate, selectedDealerId);
    fetchServiceRevenue(formattedFromDate, formattedToDate, selectedDealerId);
    fetchServiceGraph(formattedFromDate, formattedToDate, selectedDealerId);
  };

  useEffect(() => {
    fetchServiceRevenue();
  }, []);

  // const currentDate = format(new Date(), "yyyy-MM-dd");

  useEffect(() => {
    fetchServiceGraph();
  }, []);

  const fetchServiceGraph = async (fromDate, toDate, dealerId) => {
    const currentDate = new Date().toISOString().split("T")[0];
    try {
      const finalFromDate = fromDate || formattedYesterday;
      const finalToDate = toDate || formattedToday;

      const response = await axiosInstance.post(
        "/jobcard/dashboard-list-overview",

        {
          year: filterYear,
          variantId: filterVariant,
          toDate: toDate || finalToDate,
          fromDate: fromDate || finalFromDate,
          engineerId: engineerId ? parseInt(engineerId, 10) : null,
          // dealerId: dealerId || dealer_id,
          // dealerId: userType === "businesspartner" ? "" : (dealerId.toString() || dealer_id),
          dealerId:
            userType === "businesspartner"
              ? dealerId
                ? dealerId.toString()
                : ""
              : dealerId?.toString() || dealer_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response.data?.data?.graphList;
      setGraphDataVAl(fetchedData);
    } catch (error) {
      console.error("Error fetching service graph:", error);
    }
  };

  const fetchServiceRevenue = async (fromDate, toDate, dealerId) => {
    try {
      let reqServiceOverviewType = "";
      let reqServiceValue = "2025";

      if (filterYear !== "all") {
        reqServiceOverviewType = "";
        reqServiceValue = filterYear;
      } else if (filterVariant !== "all") {
        reqServiceOverviewType = "V";
        reqServiceValue = filterVariant;
      }
      const finalFromDate = fromDate || formattedYesterday;
      const finalToDate = toDate || formattedToday;

      const response = await axiosInstance.post(
        "/jobcard/dashboard-list-revanue",
        {
          reqServiceOverviewType,
          reqServiceValue,
          toDate: toDate || finalToDate,
          fromDate: fromDate || finalFromDate,
          engineerId: engineerId ? parseInt(engineerId, 10) : null,

          // dealerId: dealerId || dealer_id,
          // dealerId: userType === "businesspartner" ? "" : (dealerId.toString() || dealer_id),
          dealerId:
            userType === "businesspartner"
              ? dealerId
                ? dealerId.toString()
                : ""
              : dealerId?.toString() || dealer_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response.data?.data?.totalRevenueAmount;
      // console.log(fetchedData, "DashboardDetailsRevenue");
      setRevenueAmount(fetchedData);
    } catch (error) {
      console.error("Error fetching admin list:", error);
    }
  };

  const salesDashboardDetails = useCallback(
    async (fromDate, toDate, dealerId) => {
      try {
        let reqServiceOverviewType = "Y";
        let reqServiceValue = "2025";

        if (filterYear !== "all") {
          reqServiceOverviewType = "Y";
          reqServiceValue = filterYear;
        } else if (filterVariant !== "all") {
          reqServiceOverviewType = "V";
          reqServiceValue = filterVariant;
        }

        const finalFromDate = fromDate || formattedYesterday;
        const finalToDate = toDate || formattedToday;

        const response = await axiosInstance.post(
          `jobcard/dashboard-list`,
          {
            year: "",
            variantId: "",
            toDate: toDate || finalToDate,
            fromDate: fromDate || finalFromDate,
            engineerId: engineerId ? parseInt(engineerId, 10) : null,
            // dealer_id: dealerId.toString() || dealer_id,
            // dealerId: userType === "businesspartner" ? "" : (dealerId || dealer_id),
            dealerId:
              userType === "businesspartner"
                ? dealerId
                  ? dealerId.toString()
                  : ""
                : dealerId?.toString() || dealer_id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const fetchedData = response?.data?.data;

        const firstRow = fetchedData?.firstRow;
        console.log(firstRow, "firstRow");
        setFirstRowData(firstRow);

        const secondRow = fetchedData?.secondRow;
        console.log(secondRow, "secondRow");
        setSecondRowData(secondRow);

        // const graphData = fetchedData?.graphList
        // console.log(graphData, "graphData")
        // setGraphDataVAl(graphData)

        console.log(firstRow, "dashboardResponse");
      } catch (error) {
        console.log(error, "error");
      }
    },
    [filterYear, filterVariant, setGraphDataVAl],
  );

  useEffect(() => {
    salesDashboardDetails();
  }, [filterYear, filterVariant, salesDashboardDetails]);

  useEffect(() => {
    getVariantDetails();
  }, []);

  const getVariantDetails = async () => {
    try {
      const response = await axiosInstance.post(`/variant/ddlvariant`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      setVariantOptions(response?.data?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  const currentYear = new Date().getFullYear();
  const lastFiveYears = Array.from(
    { length: 3 },
    (_, i) => currentYear - i,
  ).reverse(); // Creates an array from current year to the last 4 years

  // Convert graphDataVal object to array of data points
  //   const dataPoints = useMemo(() => {
  //     return Object.entries(graphDataVal)?.map(([month, value]) => ({
  //         label: month,
  //         y: value,
  //     }));
  // }, [graphDataVal]);

  const dataPoints = useMemo(() => {
    return Object.entries(graphDataVal)
      .map(([month, value]) => ({
        label: month,
        y: value,
      }))
      .reverse(); // 👈 Reverses the month order
  }, [graphDataVal]);
  const options = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light2",
    title: {
      text: "",
    },
    axisX: {
      title: "",
      labelFontColor: "#5A5757",
      gridThickness: 1,
      gridColor: "#E0E0E0",
      interval: 1,
      labelAngle: -45,
    },
    axisY: {
      title: "",
      includeZero: true,
      labelFontColor: "#5A5757",
      gridThickness: 1,
      gridColor: "#E0E0E0",
      interval: 5,
    },
    data: [
      {
        type: "column",
        dataPointWidth: 10,
        indexLabelFontColor: "#5A5757",
        indexLabelPlacement: "outside",
        dataPoints: dataPoints,
      },
    ],
  };

  // const options = {
  //   animationEnabled: true,
  //   exportEnabled: true,
  //   theme: "light2",
  //   title: {
  //     text: "",
  //   },
  //   axisX: {
  //     title: "",
  //     labelFontColor: "#5A5757",
  //     gridThickness: 1,
  //     gridColor: "#E0E0E0",
  //   },
  //   axisY: {
  //     title: "",
  //     includeZero: true,
  //     labelFontColor: "#5A5757",
  //     gridThickness: 1,
  //     gridColor: "#E0E0E0",
  //   },
  //   data: [
  //     {
  //       type: "column",
  //       dataPointWidth: 10,
  //       indexLabelFontColor: "#5A5757",
  //       indexLabelPlacement: "outside",
  //       dataPoints: dataPoints,
  //     },
  //   ],
  // };

  // const options = {
  //   animationEnabled: true,
  //   exportEnabled: true,
  //   theme: "light2",
  //   title: {
  //     text: "",
  //   },
  //   axisX: {
  //     title: "",
  //     labelFontColor: "#5A5757",
  //     gridThickness: 1,
  //     gridColor: "#E0E0E0",
  //   },
  //   axisY: {
  //     title: "",
  //     includeZero: true,
  //     labelFontColor: "#5A5757",
  //     gridThickness: 1,
  //     gridColor: "#E0E0E0",
  //     interval: 1, // 👈 Force Y-axis to use whole numbers
  //   },
  //   data: [
  //     {
  //       type: "column",
  //       dataPointWidth: 10,
  //       indexLabelFontColor: "#5A5757",
  //       indexLabelPlacement: "outside",
  //       dataPoints: dataPoints,
  //     },
  //   ],
  // };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #7BD755",
      boxShadow: "none",
      borderRadius: "20px",
      backgroundColor: "#fff",
      color: "#7BD755",
      width: "200px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "green",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#7BD755",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#7BD755",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#7BD755" : provided.backgroundColor,
      color: state.isFocused ? "#fff" : "#000",
    }),
  };

  const handleBusinessPartnerChange = (selectedOption) => {
    const dealerId = selectedOption?.value || null;
    setSelectedDealerId(dealerId);
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    fetchServiceRevenue(formattedDate, formattedDate, dealerId);
    salesDashboardDetails(formattedDate, formattedDate, dealerId);
    fetchServiceGraph(formattedDate, formattedDate, dealerId);
  };

  useEffect(() => {
    if (filterVariant || filterYear) {
      const currentDate = new Date().toISOString().split("T")[0];
      fetchServiceGraph(currentDate, currentDate, selectedDealerId);
    }
  }, [filterVariant, filterYear]);

  return (
    <div className="">
      <div className="service-dashboard-main">
        <div className="filters-container mx-4">
          <div
            className="filtercontainer mt-3 mb-3"
            style={{
              display: "flex",
              flexDirection: "row",
              paddingLeft: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              {/* <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  // justifyContent: "space-between",
                  justifyContent: dealer_id == 0 ? " flex-end" : "space-between",
                  width: "100%",
                }}
              > */}
              <div
                className={`filter-header ${dealer_id == 0 ? "with-dealer" : "no-dealer"}`}
              >
                {dealer_id == 0 ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginRight: "1rem",
                    }}
                  >
                    <span>Select Dealer</span>
                    <Form.Group
                      controlId="formMonth"
                      className="filter-dropdown"
                    >
                      <Select
                        isClearable
                        styles={customStyles}
                        options={dealerDd}
                        onChange={handleBusinessPartnerChange}
                        placeholder="Select Dealer"
                      />
                    </Form.Group>
                  </div>
                ) : null}

                <div className="filter-buttons">
                  <div
                    style={{
                      display: " flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <button
                      style={{ marginTop: "10px", borderRadius: "24px" }}
                      // className="submit-btn"
                      className={`filter-button ${
                        activeFilter === "24Hours" ? " active" : ""
                      }`}
                      onClick={() => handleDateSelection("24Hours")}
                    >
                      24 Hours
                    </button>
                    <button
                      style={{ marginTop: "10px", borderRadius: "24px" }}
                      // className="submit-btn"
                      className={`filter-button ${
                        activeFilter === "Week" ? "active" : ""
                      }`}
                      onClick={() => handleDateSelection("Week")}
                    >
                      Last Week
                    </button>
                    <button
                      style={{ marginTop: "10px", borderRadius: "24px" }}
                      // className="submit-btn"
                      className={`filter-button ${
                        activeFilter === "Month" ? "active" : ""
                      }`}
                      onClick={() => handleDateSelection("Month")}
                    >
                      Last Month
                    </button>
                    <button
                      style={{ marginTop: "10px", borderRadius: "24px" }}
                      // className="submit-btn"
                      className={`filter-button ${
                        activeFilter === "Year" ? "active" : ""
                      }`}
                      onClick={() => handleDateSelection("Year")}
                    >
                      Last Year
                    </button>
                    <span className="date-range-servicedashboard">
                      <MdAccessTime className="icon" />
                      <span className="text">
                        {fromDate} <span className="separator">to</span>{" "}
                        {toDate}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div>
                <div
                  style={{ display: "none" }}
                  className="searchinput-wrapper"
                >
                  <input
                    type="text"
                    className="searchinput"
                    placeholder="Search Here"
                    value=""
                    onChange={() => {}}
                  />
                  <img
                    src={searchIcon}
                    alt="Search"
                    className="searchinput-icon"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mainCardsContainer mx-4">
          {/* <div className="maintotalleadscontainer">
            <div className="maintotalsContainers">
              <div className="totalrevenuetitle">
                <div className="maintotalicons">
                  <img src={revenueIcon} />
                </div>
                <h5 style={{fontWeight:"600"}} className="mt-2">Job Card Po Amount</h5>
              </div>

              <span className="viewdetails">
                <img
                  style={{ display: "none" }}
                  className="viewimage"
                  src={viewDetailsIcon}
                />
              </span>
            </div>
            <div className="AmountContaner mt-3">
              <h3 className="total"> {revenueAmount || "0"} </h3>
              <div>
                <div className="profitContainer">
                 
                </div>
                
              </div>
            </div>
          </div> */}

          {userType !== "engineeruser" && (
            <div className="maintotalleadscontainer">
              <div className="maintotalsContainers">
                <div className="totalrevenuetitle">
                  <div className="maintotalicons">
                    <img src={revenueIcon} />
                  </div>
                  <h5 style={{ fontWeight: "600" }} className="mt-2">
                    Job Card Po Amount
                  </h5>
                </div>

                <span className="viewdetails">
                  <img
                    style={{ display: "none" }}
                    className="viewimage"
                    src={viewDetailsIcon}
                  />
                </span>
              </div>
              <div className="AmountContaner mt-3">
                <h3 className="total">{revenueAmount || "0"}</h3>
                <div>
                  <div className="profitContainer">
                    {/* <img src={arrowUpIcon} />
          <span>2%</span>{" "} */}
                  </div>
                  {/* <p className="last24hrs">Last 24 Hours</p> */}
                </div>
              </div>
            </div>
          )}

          <div className="maintotalleadscontainer">
            <div className="maintotalsContainers">
              <div className="totalrevenuetitle">
                <div className="maintotalicons">
                  <img src={ServiceIcon} />
                </div>
                <h5 style={{ fontWeight: "600" }} className="mt-2">
                  Total Service
                </h5>
              </div>

              <span className="viewdetails">
                <img
                  style={{ cursor: "pointer" }}
                  onClick={navigateToService}
                  className="viewimage"
                  // src={viewDetailsIcon}
                />
              </span>
            </div>
            <div className="AmountContaner mt-3">
              <h3 className="total">{firstRowData.totalServices || "0"} </h3>
              <div>
                <div className="profitContainer">
                  {/* <img src={arrowUpIcon} />
                  <span>2%</span>{" "} */}
                </div>
                {/* <p className="last24hrs">Last 24 Hours</p> */}
              </div>
            </div>
          </div>
          <div className="maintotalleadscontainer">
            <div className="maintotalsContainers">
              <div className="totalrevenuetitle">
                <div className="maintotalicons">
                  <img src={revenueIcon} />
                </div>
                <h5 style={{ fontWeight: "600" }} className="mt-2">
                  Total Service Cost
                </h5>
              </div>

              <span className="viewdetails">
                <img
                  style={{ display: "none" }}
                  className="viewimage"
                  src={viewDetailsIcon}
                />
              </span>
            </div>
            <div className="AmountContaner mt-3">
              <h3 className="total"> {firstRowData.totalCost || "0"}</h3>
              <div>
                <div className="profitContainer">
                  {/* <img src={arrowUpIcon} />
                  <span>2%</span>{" "} */}
                </div>
                {/* <p className="last24hrs">Last 24 Hours</p> */}
              </div>
            </div>
          </div>
        </div>
        <Container fluid>
          <div
            style={{ paddingTop: "20px" }}
            className="mainCardsContainer mx-4"
          >
            <div className="maintotalleadscontainer">
              <div className="maintotalsContainers">
                <div className="totalrevenuetitle">
                  <h5
                    style={{
                      fontWeight: "600",
                      fontSize: "20px",
                      paddingLeft: "22px",
                    }}
                  >
                    Job Card Status
                  </h5>
                </div>
              </div>
              <div className="AmountContaner mt-3">
                <div
                  className="service-types-counts"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: " flex",
                      flexDirection: "column",
                      width: "280px",
                      padding: "15px",
                      background: "#F5F9FF",
                      textAlign: "center",
                    }}
                  >
                    <div style={{ fontSize: "14px" }}>Total</div>
                    <div style={{ fontSize: "20px", fontWeight: "600" }}>
                      {secondRowData?.total || 0}
                    </div>
                  </div>
                  <div
                    style={{
                      display: " flex",
                      flexDirection: "column",
                      width: "280px",
                      padding: "15px",
                      background: "#F5F9FF",
                      textAlign: "center",
                    }}
                  >
                    <div style={{ fontSize: "14px" }}>Pending</div>
                    <div style={{ fontSize: "20px", fontWeight: "600" }}>
                      {secondRowData?.totalPending || 0}
                    </div>
                  </div>
                  <div
                    style={{
                      display: " flex",
                      flexDirection: "column",
                      width: "280px",
                      padding: "15px",
                      background: "#F5F9FF",
                      textAlign: "center",
                    }}
                  >
                    <div style={{ fontSize: "14px" }}>Reject</div>
                    <div style={{ fontSize: "20px", fontWeight: "600" }}>
                      {secondRowData?.totalReajct || 0}
                    </div>
                  </div>
                  <div
                    style={{
                      display: " flex",
                      flexDirection: "column",
                      width: "280px",
                      padding: "15px",
                      background: "#F5F9FF",
                      textAlign: "center",
                    }}
                  >
                    <div style={{ fontSize: "14px" }}>Done</div>
                    <div style={{ fontSize: "20px", fontWeight: "600" }}>
                      {secondRowData?.totalDone || 0}
                    </div>
                  </div>
                  {/* <div
                    style={{
                      display: " flex",
                      flexDirection: "column",
                      width: "280px",
                      padding: "15px",
                      background: "#F5F9FF",
                      textAlign: "center",
                    }}
                  >
                    <div style={{ fontSize: "14px" }}>Claim</div>
                      <div style={{ fontSize: "20px", fontWeight: "600" }}>
                      {secondRowData?.totalClaim || 0}
                      </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <Row>
            <Col
              style={{ padding: "40px" }}
              lg={12}
              className="charts-container"
            >
              <div className="donut-chart">
                <div className="chart-container">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        paddingLeft: "55px",
                        paddingTop: "25px",
                        fontSize: "21px",
                        fontWeight: "600",
                      }}
                    >
                      Service Overview
                    </div>

                    {/* filters */}
                    <div className="saleschart-filter">
                      <div
                        style={{
                          paddingRight: "90px",
                          paddingTop: "30px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        {/* Variant Filter */}
                        <div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingRight: "30px",
                            }}
                          >
                            {/* <select
                      value={filterVariant}
                      onChange={(e) => {
                          setFilterVariant(e.target.value);
                          setFilterYear('all'); // Reset year filter if variant is selected
                      }}
                      style={{
                          fontSize: '16px',
                          fontWeight: '400',
                          color: 'black',
                          backgroundColor: 'white',
                          border: 'none',
                          borderRadius: '4px', // Optional: add some rounding to the corners
                          padding: '8px',
                          outline: 'none', // Remove blue border on focus
                      }}
                  >
                      <option value="all"> Variants</option>
                      {variantOptions.map((variant) => (
                          <option key={variant.ID} value={variant.ID}>{variant.NAME}</option>
                      ))}
                  </select> */}
                            <select
                              value={filterVariant}
                              onChange={(e) => {
                                setFilterVariant(e.target.value);
                                // setFilterYear(''); // Optional: reset year if variant selected
                              }}
                              style={{
                                fontSize: "16px",
                                fontWeight: "400",
                                color: "black",
                                backgroundColor: "white",
                                border: "none",
                                borderRadius: "4px", // Optional: add some rounding to the corners
                                padding: "8px",
                                outline: "none", // Remove blue border on focus
                              }}
                            >
                              <option value="">Variants</option>
                              {variantOptions.map((variant) => (
                                <option key={variant.ID} value={variant.ID}>
                                  {variant.NAME}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {/* Date Filter */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginLeft: 10,
                          }}
                        >
                          <select
                            value={filterYear}
                            onChange={(e) => {
                              setFilterYear(e.target.value);
                              // setFilterVariant(''); // Optional: reset variant if year selected
                            }}
                            className="dropdownStyle"
                          >
                            <option value="">Year</option>
                            {lastFiveYears.map((year, index) => (
                              <option key={index} value={year}>
                                {year}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      padding: "0px 20px",
                      paddingTop: "40px",
                      width: "100%",
                      boxSizing: "border-box",
                    }}
                    id="chart"
                  >
                    <CanvasJSChart options={options} />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default ServiceDashboard;
